"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandTheme = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
var BrandTheme;
(function (BrandTheme) {
    BrandTheme.Schema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        brandName: centralized_zod_1.z.string(),
        headerBackgroundColor: centralized_zod_1.z.string(),
        headerTextColor: centralized_zod_1.z.string(),
        buttonTextColor: centralized_zod_1.z.string(),
        accentColor: centralized_zod_1.z.string(),
        logoUrl: centralized_zod_1.z.string(),
    });
})(BrandTheme || (BrandTheme = {}));
exports.BrandTheme = BrandTheme;
